import { useState, type ReactElement } from 'react';

import { QrDownloadDialog } from '@docuid/ui/components/qr-download-dialog';
import { useIsMobile } from '@docuid/ui/hooks/use-mobile';
import {
  ANDROID_STORE_URL,
  AndroidIcon,
  AppleIcon,
  IOS_STORE_URL,
  type QrDownloadPlatform,
} from '@docuid/ui/lib/qr-download-data';

export function IvaltDownloadBlock(): ReactElement {
  const isMobile = useIsMobile();
  const [openPlatform, setOpenPlatform] = useState<QrDownloadPlatform | null>(null);

  const openModal = (event: React.MouseEvent<HTMLAnchorElement>, platform: QrDownloadPlatform) => {
    if (isMobile) return;
    event.preventDefault();
    setOpenPlatform(platform);
  };

  return (
    <>
      <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
        <a
          href={IOS_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Download iVALT from the App Store"
          onClick={(event) => {
            openModal(event, 'ios');
          }}
          className="bg-foreground text-background hover:bg-foreground/90 inline-flex w-full items-center justify-center gap-3 rounded-full px-5 py-2.5 text-sm font-medium transition-all duration-200 sm:w-auto"
        >
          <AppleIcon className="size-5" />
          <span className="flex flex-col items-start gap-0 leading-tight">
            <span className="text-xs font-semibold">iOS</span>
            <span className="text-[11px] font-light opacity-80">App Store</span>
          </span>
        </a>
        <a
          href={ANDROID_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Get iVALT on Google Play"
          onClick={(event) => {
            openModal(event, 'android');
          }}
          className="border-border bg-card text-foreground hover:bg-muted inline-flex w-full items-center justify-center gap-3 rounded-full border px-5 py-2.5 text-sm font-medium transition-all duration-200 sm:w-auto"
        >
          <AndroidIcon className="size-5" />
          <span className="flex flex-col items-start gap-0 leading-tight">
            <span className="text-xs font-semibold">Android</span>
            <span className="text-muted-foreground text-[11px] font-light">Google Play</span>
          </span>
        </a>
      </div>

      <QrDownloadDialog
        isOpen={openPlatform !== null}
        initialPlatform={openPlatform ?? 'ios'}
        onClose={() => {
          setOpenPlatform(null);
        }}
        title="Get the iVALT app"
        subtitle="Scan the QR code with your phone camera"
      />
    </>
  );
}
